import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseDirective } from '../../../models/base/base-directive';
import { throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[appThrottleClick]',
  standalone: true
})
export class ThrottleClickDirective extends BaseDirective {
  @Input() throttleInMilliSec = 500;
  @Output() throttleClick = new EventEmitter<Event>();
  private clicks = new Subject<Event>();

  constructor() {
    super();
  }

  setupViews() {}

  setupBindings() {
    const s = this.clicks.pipe(throttleTime(this.throttleInMilliSec)).subscribe(e => this.throttleClick.emit(e));
    this.pushSub(s);
  }

  @HostListener('click', ['$event'])
  clickEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
